// extracted by mini-css-extract-plugin
export default {"lineDescription":"BCGIa","border":"BYwYC","emptyBlock":"Jrwl1"};